import React from 'react';
import { IVehicleStockParams, IVehicleStockResult } from '../../../../common';
import { ttCodeFormatter } from '../../../../utils';
import { ColLoading } from './ColLoading';
import { useClientVehicleStock } from '@common/hooks/client/useClientVehicleStock';

export const TrackAndTrace = (props: IVehicleStockParams) => {
  const { data, loading }: IVehicleStockResult = useClientVehicleStock({
    serialNo: props?.serialNo,
  });
  if (loading) return <ColLoading />;
  const traceCode = data?.trackTraceCode || null;
  return <label>{ttCodeFormatter(traceCode)}</label>;
};
